import React from "react";
import { CardFaces } from "./cardFaces.ts";
import { useTranslation } from "../Shared/i18n/useTranslation.ts";
import { format } from "../Shared/i18n/format.ts";

interface FlashCardProps {
    faces: CardFaces;
    flipped: boolean;
    onFlip: () => void;
}

/**
 * One card. Presentational only - it is told which face to show and reports a
 * tap; the deck owns the state. A real <button> so it is keyboard and screen
 * reader operable, with the whole card as the tap target.
 */
export function FlashCard({ faces, flipped, onFlip }: FlashCardProps) {
    const t = useTranslation();
    return (
        <button
            type="button"
            className={`flashCard${flipped ? " flashCardFlipped" : ""}`}
            onClick={onFlip}
            aria-label={
                flipped
                    ? format(t('flashCards.ariaFlippedTemplate'), { front: faces.front, back: faces.back })
                    : format(t('flashCards.ariaUnflippedTemplate'), { front: faces.front })
            }
        >
            <span className="flashCardProblem">{faces.front}</span>
            <span className="flashCardAnswer" aria-hidden={!flipped}>
                {flipped ? `= ${faces.back}` : t('flashCards.tapToFlip')}
            </span>
        </button>
    );
}
